const DropdownDirection = {
	BOTTOM_RIGHT: 'bottom-right',
	TOP_RIGHT: 'top-right',
};

export default DropdownDirection;
